module.exports = __webpack_public_path__ + "static/media/WeatherApp.011dc4b4.png";